var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBadgecheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1181_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7969 3.20585C16.7035 1.58112 19.5076 1.58112 21.4141 3.20585C22.2311 3.90208 23.2469 4.32283 24.3169 4.40822C26.8138 4.60748 28.7966 6.59027 28.9959 9.08724C29.0813 10.1572 29.502 11.173 30.1982 11.99C31.823 13.8965 31.823 16.7006 30.1982 18.6072C29.502 19.4241 29.0813 20.4399 28.9959 21.5099C28.7966 24.0069 26.8138 25.9897 24.3169 26.189C23.2469 26.2743 22.2311 26.6951 21.4141 27.3913C19.5076 29.0161 16.7035 29.0161 14.7969 27.3913C13.98 26.6951 12.9642 26.2743 11.8942 26.189C9.39719 25.9897 7.4144 24.0069 7.21514 21.5099C7.12975 20.4399 6.70899 19.4241 6.01276 18.6072C4.38804 16.7006 4.38804 13.8965 6.01276 11.99C6.70899 11.173 7.12975 10.1572 7.21514 9.08724C7.4144 6.59027 9.39719 4.60748 11.8942 4.40822C12.9642 4.32283 13.98 3.90208 14.7969 3.20585Z",
    fill: "#30EA64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6318 15.2986L16.6143 18.281L22.5792 12.3161M11.8942 4.40822C12.9642 4.32283 13.98 3.90208 14.7969 3.20585C16.7035 1.58112 19.5076 1.58112 21.4141 3.20585C22.2311 3.90208 23.2469 4.32283 24.3169 4.40822C26.8138 4.60748 28.7966 6.59027 28.9959 9.08724C29.0813 10.1572 29.502 11.173 30.1982 11.99C31.823 13.8965 31.823 16.7006 30.1982 18.6072C29.502 19.4241 29.0813 20.4399 28.9959 21.5099C28.7966 24.0069 26.8138 25.9897 24.3169 26.189C23.2469 26.2743 22.2311 26.6951 21.4141 27.3913C19.5076 29.0161 16.7035 29.0161 14.7969 27.3913C13.98 26.6951 12.9642 26.2743 11.8942 26.189C9.39719 25.9897 7.4144 24.0069 7.21514 21.5099C7.12975 20.4399 6.70899 19.4241 6.01276 18.6072C4.38804 16.7006 4.38804 13.8965 6.01276 11.99C6.70899 11.173 7.12975 10.1572 7.21514 9.08724C7.4144 6.59027 9.39719 4.60748 11.8942 4.40822Z",
    stroke: "#111827",
    strokeWidth: 2.98246,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1181_398",
    x: 0.495961,
    y: 0.496094,
    width: 35.2191,
    height: 35.2195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.80702
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40351
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1181_398"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1181_398",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBadgecheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/badgecheck.389636b2.svg";
export { ForwardRef as ReactComponent };